import { render, staticRenderFns } from "./podere-poggio-scalette.vue?vue&type=template&id=3c888258&scoped=true"
import script from "./podere-poggio-scalette.vue?vue&type=script&lang=js"
export * from "./podere-poggio-scalette.vue?vue&type=script&lang=js"
import style0 from "./podere-poggio-scalette.vue?vue&type=style&index=0&id=3c888258&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c888258",
  null
  
)

export default component.exports